import _ from "underscore";
import { connect } from "react-redux";
// Component
import SelectAttr from "components/CreateSurvey/SelectAttr";
// Action
import { openErrorDialog } from "redux/modules/errorDialog";
import { openMessageDialog } from "redux/modules/messageDialog";
import {
  openConfirmDialog,
  closeConfirmDialog
} from "redux/modules/confirmDialog";
import { showSnackbar } from "redux/modules/snackbar";
import {
  setErrors,
  updateSelectAttr,
  setSurveyDetail,
  reloadAttrs,
  setSelectAttrLocale,
  changeSelectAttrUseAttrs,
  changeSelectAttrItem,
  setAttrUpdateAt
} from "redux/modules/createSurvey";
// Utils
import history from "utils/history";
import { convertLocaleKeyToName } from "utils/formatter";
import api from "api";

const mapStateToProps = state => ({
  selectAttr: state.createSurvey.selectAttr,
  customer: state.createSurvey.customer,
  survey: state.createSurvey.survey,
  locales: state.createSurvey.locales,
  baseInfo: state.createSurvey.baseInfo,
  attrUpdatedAt: state.createSurvey.attrUpdatedAt,
  errors: state.createSurvey.errors
});
const selectedItems = list => {
  return _.chain(list)
    .select(rec => rec.isSelect)
    .value();
};
export const validate = (baseInfo, selectAttr) => {
  const errors = [];
  const selectedAttrIds = selectedItems(selectAttr.items);
  if (selectedAttrIds.length === 0) {
    errors.push("属性を選択してください。");
  }
  if (selectedAttrIds.length > 6) {
    errors.push("選択可能な属性は6つまでです。");
  }
  baseInfo.useLocales.forEach(useLocale => {
    selectAttr.items.forEach((sa, i) => {
      if (!sa.isSelect) return;
      if (!sa.locale[useLocale].attrName) {
        errors.push(
          `${convertLocaleKeyToName(useLocale)}: No.${i +
            1} 属性名の設定が不十分です。`
        );
      }
      if (!sa.itemCount) {
        errors.push(
          `${convertLocaleKeyToName(useLocale)}: No.${i +
            1} 選択肢の設定が不十分です。`
        );
      }
      sa.locale[useLocale].attrItems.forEach(attrItem => {
        if (!attrItem.itemName) {
          errors.push(
            `${convertLocaleKeyToName(useLocale)}: No.${i +
              1} 選択肢の設定が不十分です。`
          );
        }
      });
    });
  });
  return _.uniq(errors);
};
const checkAttrUpdateAt = (
  dispatch,
  customerId,
  attrUpdatedAt,
  func = null
) => {
  api.get(`check_attr_update_at/${customerId}`, { attrUpdatedAt }).then(res => {
    if (res.messages) {
      dispatch(openMessageDialog(res.messages[0]));
      dispatch(setAttrUpdateAt(res.attrUpdatedAt));
    } else if (func) func();
    return res;
  });
};
const mapDispatchToProps = (dispatch, ownProps) => ({
  historyPush: path => history.push(path, ownProps),

  fetchSurveyDetail: () => {
    if (ownProps.match.path.indexOf("create_survey") > -1) {
      return;
    }
    const { id } = ownProps.match.params;
    api
      .get(`survey_detail/${id}`)
      .then(res => dispatch(setSurveyDetail(res)))
      .catch(error => dispatch(openErrorDialog(error)));
  },
  handleReload: (customer, survey, selectAttr) => {
    const selectedAttrIds = _.pluck(selectedItems(selectAttr.items), "id");
    const params = {
      customerId: customer.id,
      surveyId: survey.id,
      selectedAttrIds
    };
    api
      .get(`survey_attr/reload`, params)
      .then(res => {
        dispatch(reloadAttrs(res));
        dispatch(closeConfirmDialog());
        dispatch(showSnackbar("属性設定の内容を反映しました。"));
      })
      .catch(error => dispatch(openErrorDialog(error)));
  },
  handleNext: props => {
    const { baseInfo, selectAttr, attrUpdatedAt, customerId } = props;
    const errors = validate(baseInfo, selectAttr);
    dispatch(setErrors(errors));
    if (errors.length > 0) {
      window.scroll(0, 0);
      return;
    }
    checkAttrUpdateAt(dispatch, customerId, attrUpdatedAt, () =>
      history.push(`/create_survey/${customerId}/base_word`, ownProps)
    );
  },
  handlePrev: props => {
    const { attrUpdatedAt, customerId } = props;
    dispatch(setErrors([]));
    checkAttrUpdateAt(dispatch, customerId, attrUpdatedAt, () =>
      ownProps.history.goBack()
    );
  },
  handleUpdate: props => {
    const { survey, baseInfo, selectAttr, attrUpdatedAt, customerId } = props;
    const errors = validate(baseInfo, selectAttr);
    dispatch(setErrors(errors));
    if (errors.length > 0) {
      window.scroll(0, 0);
      return;
    }

    const params = {
      survey: survey.toObject(),
      selectAttr,
      check_flg: 0
    };
    const { id } = ownProps.match.params;
    const dialogData = {
      title: "確認",
      contentText: "使用する属性を更新します。よろしいですか？",
      btnLabel: "更新",
      handleClick: () => {
        api
          .post(`update_select_attr/${id}`, params)
          .then(res => {
            dispatch(closeConfirmDialog());
            dispatch(updateSelectAttr());

            if (res.errors) {
              dispatch(openErrorDialog(res.errors));
            } else {
              dispatch(showSnackbar("使用する属性を更新しました。"));
              ownProps.history.goBack();
            }
          })
          .catch(error => dispatch(openErrorDialog(error)));
      }
    };
    checkAttrUpdateAt(dispatch, customerId, attrUpdatedAt, () =>
      dispatch(openConfirmDialog(dialogData))
    );
  },
  changeLocale: (event, localeNo) => {
    dispatch(setSelectAttrLocale(localeNo));
  },
  changeUseAttrs: (event, index) => {
    dispatch(changeSelectAttrUseAttrs(event.target.checked, index));
  },
  changeItem: (key, value) => {
    dispatch(changeSelectAttrItem(key, value));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(SelectAttr);



// WEBPACK FOOTER //
// ./src/containers/CreateSurvey/SelectAttr/index.js